import { storeLocale } from "../../actions/localization/actions";
export var localisationDispatch = function(dispatch) {
    return {
        dispatchStoreLocale: function(payload) {
            dispatch(storeLocale(payload));
        }
    };
};
export default localisationDispatch;

//# sourceMappingURL=localisationDispatch.js.map